module.exports = __webpack_public_path__ + "static/media/01_A1_03.8621b9f0.png";